import {
  DOOR_GLASS_8,
  DOOR_GLASS_10,
  DOOR_GLASS_12,
  DOOR_GLASS_1076,
  DOOR_GLASS_1276,
} from './doorGlassTypes';

const doorGlassTypes = [
  DOOR_GLASS_8,
  DOOR_GLASS_10,
  DOOR_GLASS_12,
  DOOR_GLASS_1076,
  DOOR_GLASS_1276,
];

export default doorGlassTypes;
